import axios from "axios";
import { jwtDecode } from "jwt-decode";

export const fetchChatGPTResponse = async (content) => {
  try {
    const response = await axios.post(
      "https://api.openai.com/v1/chat/completions",
      {
        model: "gpt-3.5-turbo",
        messages: [{ role: "user", content }],
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${process.env.REACT_APP_CHATBOT_API}`, // Make sure this variable is in your .env file
        },
      },
    );
    return response.data.choices[0].message.content;
  } catch (error) {
    console.error("Error fetching response from ChatGPT:", error);
    throw error;
  }
};
export const headers = () => {
  const token = localStorage.getItem("vyg_access_token");
  const decodedToken = token ? jwtDecode(token) : "";
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    "X-TENANT-ID": decodedToken.tenant,
  };
};

export const jwtDetails = () => {
  const token = localStorage.getItem("vyg_access_token");
  const decodedToken = token ? jwtDecode(token) : "";

  return decodedToken;
};

export const tenant = () => {
  const token = localStorage.getItem("vyg_access_token");
  const decodedToken = token ? jwtDecode(token) : "";
  return decodedToken.tenant;
};

export const loginMemberId = () => {
  const token = localStorage.getItem("vyg_access_token");
  const decodedToken = token ? jwtDecode(token) : "";
  return decodedToken.sub;
};

export const roles = () => {
  const token = localStorage.getItem("vyg_access_token");
  const decodedToken = token ? jwtDecode(token) : "";

  const defaultRoles = [
    "offline_access",
    "uma_authorization",
    "default-roles-eVyoog",
  ];

  const filteredRoles = decodedToken?.realm_access?.roles?.filter(
    (role) => !defaultRoles.includes(role),
  );

  return filteredRoles;
};

export const realmeMangementRoles = () => {
  const token = localStorage.getItem("vyg_access_token");
  const decodedToken = token ? jwtDecode(token) : "";
  return decodedToken?.resource_access?.["realm-management"]?.roles || [];
};

export const hasRole = (role) => {
  const userRoles = [...roles(), ...realmeMangementRoles()];

  return userRoles?.includes(role) || userRoles?.includes("realm-admin");
};

export const oauthHeaders = () => {
  const token = localStorage.getItem("vyg_access_token");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};
export const attachmentHeaders = () => {
  const token = localStorage.getItem("vyg_access_token");
  const decodedToken = token ? jwtDecode(token) : "";
  return {
    Authorization: `Bearer ${token}`,
    "X-TENANT-ID": decodedToken.tenant,
  };
};

export const oauthUserMgmt = () => {
  const token = localStorage.getItem("vyg_access_token");

  if (token) {
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  }
  return null;
};

export const userLogOut = () => {
  localStorage.removeItem("vyg_access_token");
  localStorage.removeItem("vyg_refresh_token");
  localStorage.removeItem("vyg_login_user");
  window.location.reload();
};

export const convertGMTToIST = (gmtTime) => {
  // Parse the GMT time into a Date object
  const date = new Date(gmtTime);

  // Calculate IST time by adding 5 hours and 30 minutes
  const offsetInMilliseconds = 5.5 * 60 * 60 * 1000; // 5.5 hours in milliseconds
  const istDate = new Date(date.getTime() + offsetInMilliseconds);

  return istDate.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
};
export const systemConfig = async (id) => {
  const response = await fetch(
    process.env.REACT_APP_SYS_CONFIG_MGMT + "/systemConfig/show/" + id,
    {
      method: "GET",
      headers: headers(),
    },
  );
  const data = await response.json();
  return data;
};
export const adminLogin = async () => {
  const response = await fetch(process.env.REACT_APP_OAUTH_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams({
      username: "sandboxadmin",
      password: "123",
      client_id: "eVyoog",
      client_secret: "ssFF0O7wX5UlmWECCxjfOmflw4WRSJng",
      grant_type: "password",
    }),
  });
  const data = await response.json();
console.log("KOG",data)
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${data.access_token}`,
  };
};
